import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import styled from 'styled-components';
// import Paragraph from '../Paragraph/Paragraph';
import themeColors from '../../assets/styles/themeColors';
import { ReactComponent as Caret } from '../../assets/images/svg/down.svg';
import { BalanceCardIcon } from '../Portfolio/Balance/BalanceCard';
import { mediaBelow, pxToRem, pxToRemMd } from '../../assets/styles/helper';
import ModalButtons from '../Modal/ModalButtons';
// import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import Modal from '../Modal/Modal';
import ModalBody from '../Modal/ModalBody';
import { BANK_ACCOUNTS_PAGE, CREDIT_CARDS_PAGE } from '../../constants/pages';
import { variables } from '../../assets/styles/variables';
import Button from '../Button/Button';
import { uFlexCenter } from '../../assets/styles/utility';

const DiscountFlag = styled.div`
  color: ${themeColors.colorWhite};
  background-color: ${themeColors.colorPrimary};
  border-radius: 4px;
  padding: 3px;
  font-size: ${pxToRemMd(12)};
`;

export const AddPaymentMethodButton = styled.div`
  border: 1px solid ${themeColors.colorBorderPrimary};
  background-color: ${themeColors.colorBackgroundPrimary};
  box-shadow: ${variables.shadow.boxShadow};
  margin-top: ${pxToRem(16)};
  ${({ disabled }) =>
    disabled &&
    `opacity: 0.5;
      pointer-events: none;
      `}
`;

export const AddPaymentMethodIconAndTextWrapper = styled.div`
  display: flex;
  flex: 1;
`;

export const AddPaymentMethodElement = styled(Button)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0;
  box-shadow: none;
  padding: ${pxToRem(12.5)} ${pxToRem(16.5)};
  text-transform: capitalize;
  justify-content: flex-start;
  font-weight: 600;
  color: ${themeColors.colorTextPrimary};
  font-size: ${pxToRem(16)};
  width: 100%;

  ${mediaBelow(variables.breakpoints.bpMd)} {
    font-size: ${pxToRemMd(16)};
  }
`;

export const AddPaymentMethodIcon = styled.div`
  ${uFlexCenter};
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  border-radius: 4px;
  background-color: ${themeColors.colorPrimary};
  box-shadow: ${variables.shadow.boxShadow};
  margin-right: ${pxToRem(10)};
  flex-shrink: 0;
  padding: ${pxToRem(3)};
  color: ${themeColors.colorWhite};

  svg {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    color: ${themeColors.colorWhite};
  }
`;

export const HorizontalLine = styled.hr`
  width: 100%;
  height: 1px;
  background-color: ${themeColors.colorInputBorder};
  border-width: 0;
`;

export const AddPaymentMethodNote = styled.p`
  padding: 0px ${pxToRem(12.5)} ${pxToRem(12.5)} ${pxToRem(14)};
`;

export const AddPaymentMethodButtonText = styled.span``;

const AddPaymentMethod = ({ onClose, isOpen }) => {
  const { t } = useTranslation();
  const history = useHistory();
  // const [creditCardLimit, setCreditCardLimit] = useState('');
  // const [bankLimit, setBankLimit] = useState('');

  // useEffect(() => {
  //   if (paymentMethods) {
  //     const ccLimit = paymentMethods.find(
  //       (method) => method?.PaymentMethodType === 3,
  //     )?.MaximumLimit;
  //     const bLimit = paymentMethods.find(
  //       (method) => method?.PaymentMethodType === 2,
  //     )?.MaximumLimit;
  //     setCreditCardLimit(ccLimit);
  //     setBankLimit(bLimit);
  //   }
  // }, [paymentMethods]);

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        close={handleClose}
        title={t('buyWizard.postPaid.addPaymentMethodModalTitle')}
        size="sm"
        avoidClearingStorage
      >
        <ModalBody>
          <AddPaymentMethodButton
            onClick={() => history.push(BANK_ACCOUNTS_PAGE)}
          >
            <AddPaymentMethodElement>
              <AddPaymentMethodIconAndTextWrapper>
                <AddPaymentMethodButtonText>
                  {t('buyWizard.postPaid.achBankConnectionButton')}
                </AddPaymentMethodButtonText>
              </AddPaymentMethodIconAndTextWrapper>
              <DiscountFlag>
                {t('buyWizard.postPaid.discountFlag')}
              </DiscountFlag>
            </AddPaymentMethodElement>
            <AddPaymentMethodNote>
              {t('buyWizard.postPaid.achBankConnectionButtonInfo')}
              {/* <Paragraph
                fontSize={16}
                color={themeColors.colorTextSecondary}
                marginTop={10}
                bold
              >
                {t('buyWizard.postPaid.limitPerDay', {
                  limitAmount: formatMoneyNumeral(bankLimit),
                })}
              </Paragraph> */}
            </AddPaymentMethodNote>
          </AddPaymentMethodButton>
          <AddPaymentMethodButton
            onClick={() => history.push(CREDIT_CARDS_PAGE)}
          >
            <AddPaymentMethodElement>
              <AddPaymentMethodIconAndTextWrapper>
                <AddPaymentMethodButtonText>
                  {t('buyWizard.postPaid.creditCardButton')}
                </AddPaymentMethodButtonText>
              </AddPaymentMethodIconAndTextWrapper>
              <BalanceCardIcon>
                <Caret />
              </BalanceCardIcon>
            </AddPaymentMethodElement>
            <AddPaymentMethodNote>
              {t('buyWizard.postPaid.creditCardButtonInfo')}
              {/* <Paragraph
                fontSize={16}
                color={themeColors.colorTextSecondary}
                marginTop={10}
                bold
              >
                {t('buyWizard.postPaid.limitPerOrder', {
                  limitAmount: formatMoneyNumeral(creditCardLimit),
                })}
              </Paragraph> */}
            </AddPaymentMethodNote>
          </AddPaymentMethodButton>

          <ModalButtons
            marginTop
            isVertical
            showOnlySecondary
            secondaryButtonProps={{
              onClick: onClose,
              label: t('common.cancel'),
            }}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

AddPaymentMethod.propTypes = {
  // paymentMethods: PropTypes.arrayOf({}),
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};

export default AddPaymentMethod;
